import React from 'react';

import RoomsList from './component';

export default React.memo(RoomsList);
